import { PlusOutlined } from "@ant-design/icons";
import React from "react";
import imageCompression from "browser-image-compression";

export const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const fetchImageAsBase64 = async (url) => {
  try {
    const response = await fetch(url, { mode: "cors" });
    if (!response.ok) throw new Error("Failed to fetch image");
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch {
    return url;
  }
};

export const createHandleUpload = (messageApi) => async (options) => {
  const { file, onSuccess, onError } = options;

  try {
    // compress image
    const compressedFile = await imageCompression(file, {
      maxSizeMB: 2,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    });

    // preview
    const preview = URL.createObjectURL(compressedFile);

    setTimeout(() => {
      onSuccess({
        url: preview,
        thumbUrl: preview,
        originFileObj: compressedFile,
      });

      messageApi.success("uploaded successfully.");
    });
  } catch (err) {
    console.error("[createHandleUpload] createHandleUpload: ", err);
    onError(err);
    const { message } = settings.getErrorMessage(err);
    messageApi.error(`${message}`);
  }
};

export const createHandlePreview = (setPreviewImage, setPreviewOpen) => async (file) => {
  if (!file.url && !file.preview && file.originFileObj) {
    file.preview = URL.createObjectURL(file.originFileObj);
  }
  setPreviewImage(file.url || file.preview || file.thumbUrl);
  setPreviewOpen(true);
};

export const UploadButton = () => (
  <button
    style={{
      border: 0,
      background: "none",
      color: "#000",
    }}
    type="button"
  >
    <PlusOutlined />
    <div
      style={{
        marginTop: 8,
        color: "#000",
      }}
    >
      Upload
    </div>
  </button>
);

export const ImagePreview = ({ previewImage, previewOpen, setPreviewOpen, setPreviewImage, Image }) => {
  if (!previewImage) return null;

  return (
    <Image
      wrapperStyle={{ display: "none" }}
      preview={{
        visible: previewOpen,
        onVisibleChange: (visible) => setPreviewOpen(visible),
        afterOpenChange: (visible) => !visible && setPreviewImage(""),
      }}
      src={previewImage}
    />
  );
};
